/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '..';

export const UnicornDetectorIcon = (props: IconTypeProps) => {
  const {
    className,
    id,
    onClick,
    color: colorFromProps,
    size: sizeFromProps,
    style: styleFromProps,
  } = props;
  const color = colorFromProps || '#40A9FF';
  const size = sizeFromProps || 40;

  const style = {
    ...styleFromProps,
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <svg
      id={id}
      width="53"
      height="53"
      viewBox="0 0 53 53"
      className={className}
      style={style}
      onClick={onClick}
    >
      <g filter="url(#filter0_d_711_48125)">
        <circle cx="26.1624" cy="26.1611" r="18.5" fill="white" />
      </g>
      <circle cx="26.1617" cy="26.161" r="16.4891" fill="#10239E" />
      <circle cx="26.1617" cy="26.161" r="16.4891" stroke="#BAE7FF" />
      <mask id="path-3-inside-1_711_48125" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.1839 25.9221C37.1839 32.1413 32.1423 37.1829 25.9231 37.1829C19.7039 37.1829 14.6622 32.1413 14.6622 25.9221C14.6622 19.7029 19.7039 14.6612 25.9231 14.6612C32.1423 14.6612 37.1839 19.7029 37.1839 25.9221ZM36.1839 25.9221C36.1839 31.589 31.59 36.1829 25.9231 36.1829C20.2561 36.1829 15.6622 31.589 15.6622 25.9221V25.9112C15.6622 20.2503 20.2513 15.6612 25.9122 15.6612H25.9231C31.59 15.6612 36.1839 20.2551 36.1839 25.9221Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.5972 26.1614C32.5972 29.7152 29.7162 32.5962 26.1624 32.5962C22.6086 32.5962 19.7276 29.7152 19.7276 26.1614C19.7276 22.6076 22.6086 19.7266 26.1624 19.7266C29.7162 19.7266 32.5972 22.6076 32.5972 26.1614ZM31.6622 26.1612C31.6622 29.1988 29.1998 31.6612 26.1622 31.6612C23.1246 31.6612 20.6622 29.1988 20.6622 26.1612C20.6622 23.1236 23.1246 20.6612 26.1622 20.6612C29.1998 20.6612 31.6622 23.1236 31.6622 26.1612Z"
        />
        <path d="M26.1619 9.67188H26.5641V42.6501H26.1619V9.67188Z" />
        <path d="M9.67261 26.5629V26.1607H42.6509V26.5629H9.67261Z" />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.1839 25.9221C37.1839 32.1413 32.1423 37.1829 25.9231 37.1829C19.7039 37.1829 14.6622 32.1413 14.6622 25.9221C14.6622 19.7029 19.7039 14.6612 25.9231 14.6612C32.1423 14.6612 37.1839 19.7029 37.1839 25.9221ZM36.1839 25.9221C36.1839 31.589 31.59 36.1829 25.9231 36.1829C20.2561 36.1829 15.6622 31.589 15.6622 25.9221V25.9112C15.6622 20.2503 20.2513 15.6612 25.9122 15.6612H25.9231C31.59 15.6612 36.1839 20.2551 36.1839 25.9221Z"
        fill="#2F54EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5972 26.1614C32.5972 29.7152 29.7162 32.5962 26.1624 32.5962C22.6086 32.5962 19.7276 29.7152 19.7276 26.1614C19.7276 22.6076 22.6086 19.7266 26.1624 19.7266C29.7162 19.7266 32.5972 22.6076 32.5972 26.1614ZM31.6622 26.1612C31.6622 29.1988 29.1998 31.6612 26.1622 31.6612C23.1246 31.6612 20.6622 29.1988 20.6622 26.1612C20.6622 23.1236 23.1246 20.6612 26.1622 20.6612C29.1998 20.6612 31.6622 23.1236 31.6622 26.1612Z"
        fill="#2F54EB"
      />
      <path
        d="M26.1619 9.67188H26.5641V42.6501H26.1619V9.67188Z"
        fill="#91D5FF"
      />
      <path
        d="M9.67261 26.5629V26.1607H42.6509V26.5629H9.67261Z"
        fill="#91D5FF"
      />
      <path
        d="M26.1619 9.67188V8.67188H25.1619V9.67188H26.1619ZM26.5641 9.67188H27.5641V8.67188H26.5641V9.67188ZM26.5641 42.6501V43.6501H27.5641V42.6501H26.5641ZM26.1619 42.6501H25.1619V43.6501H26.1619V42.6501ZM9.67261 26.5629H8.67261V27.5629H9.67261V26.5629ZM9.67261 26.1607V25.1607H8.67261V26.1607H9.67261ZM42.6509 26.1607H43.6509V25.1607H42.6509V26.1607ZM42.6509 26.5629V27.5629H43.6509V26.5629H42.6509ZM25.9231 37.1829C32.1423 37.1829 37.1839 32.1413 37.1839 25.9221H35.1839C35.1839 31.0367 31.0377 35.1829 25.9231 35.1829V37.1829ZM14.6622 25.9221C14.6622 32.1413 19.7039 37.1829 25.9231 37.1829V35.1829C20.8084 35.1829 16.6622 31.0367 16.6622 25.9221H14.6622ZM25.9122 14.6612C19.699 14.6612 14.6622 19.698 14.6622 25.9112H16.6622C16.6622 20.8026 20.8036 16.6612 25.9122 16.6612V14.6612ZM37.1839 25.9221C37.1839 19.7029 32.1423 14.6612 25.9231 14.6612V16.6612C31.0377 16.6612 35.1839 20.8074 35.1839 25.9221H37.1839ZM25.9231 38.1829C32.6945 38.1829 38.1839 32.6936 38.1839 25.9221H36.1839C36.1839 31.589 31.59 36.1829 25.9231 36.1829V38.1829ZM13.6622 25.9221C13.6622 32.6936 19.1516 38.1829 25.9231 38.1829V36.1829C20.2561 36.1829 15.6622 31.589 15.6622 25.9221H13.6622ZM25.9231 13.6612C19.1516 13.6612 13.6622 19.1506 13.6622 25.9221H15.6622C15.6622 20.2551 20.2561 15.6612 25.9231 15.6612V13.6612ZM38.1839 25.9221C38.1839 19.1506 32.6945 13.6612 25.9231 13.6612V15.6612C31.59 15.6612 36.1839 20.2551 36.1839 25.9221H38.1839ZM14.6622 25.9112V25.9221H16.6622V25.9112H14.6622ZM25.9231 14.6612H25.9122V16.6612H25.9231V14.6612ZM26.1624 33.5962C30.2685 33.5962 33.5972 30.2675 33.5972 26.1614H31.5972C31.5972 29.163 29.1639 31.5962 26.1624 31.5962V33.5962ZM18.7276 26.1614C18.7276 30.2675 22.0563 33.5962 26.1624 33.5962V31.5962C23.1609 31.5962 20.7276 29.163 20.7276 26.1614H18.7276ZM26.1624 18.7266C22.0563 18.7266 18.7276 22.0553 18.7276 26.1614H20.7276C20.7276 23.1599 23.1609 20.7266 26.1624 20.7266V18.7266ZM33.5972 26.1614C33.5972 22.0553 30.2685 18.7266 26.1624 18.7266V20.7266C29.1639 20.7266 31.5972 23.1599 31.5972 26.1614H33.5972ZM26.1622 32.6612C29.752 32.6612 32.6622 29.751 32.6622 26.1612H30.6622C30.6622 28.6465 28.6475 30.6612 26.1622 30.6612V32.6612ZM19.6622 26.1612C19.6622 29.751 22.5723 32.6612 26.1622 32.6612V30.6612C23.6769 30.6612 21.6622 28.6465 21.6622 26.1612H19.6622ZM26.1622 19.6612C22.5723 19.6612 19.6622 22.5713 19.6622 26.1612H21.6622C21.6622 23.6759 23.6769 21.6612 26.1622 21.6612V19.6612ZM32.6622 26.1612C32.6622 22.5713 29.752 19.6612 26.1622 19.6612V21.6612C28.6475 21.6612 30.6622 23.6759 30.6622 26.1612H32.6622ZM26.1619 10.6719H26.5641V8.67188H26.1619V10.6719ZM25.5641 9.67188V42.6501H27.5641V9.67188H25.5641ZM26.5641 41.6501H26.1619V43.6501H26.5641V41.6501ZM27.1619 42.6501V9.67188H25.1619V42.6501H27.1619ZM10.6726 26.5629V26.1607H8.67261V26.5629H10.6726ZM9.67261 27.1607H42.6509V25.1607H9.67261V27.1607ZM41.6509 26.1607V26.5629H43.6509V26.1607H41.6509ZM42.6509 25.5629H9.67261V27.5629H42.6509V25.5629Z"
        fill="#2F54EB"
        mask="url(#path-3-inside-1_711_48125)"
      />
      <g filter="url(#filter1_d_711_48125)">
        <path
          d="M26.8015 26.8723C26.1624 27.3398 25.6624 26.3398 25.9491 26.0185L37.646 14.3402L38.4984 15.194L26.8015 26.8723Z"
          fill="url(#paint0_linear_711_48125)"
        />
      </g>
      <g filter="url(#filter2_f_711_48125)">
        <path
          d="M13.0815 39.2446C11.3636 37.5267 10.0009 35.4872 9.07121 33.2427C8.14149 30.9982 7.66298 28.5925 7.66298 26.1631C7.66298 23.7336 8.14149 21.328 9.07121 19.0834C10.0009 16.8389 11.3636 14.7995 13.0815 13.0816C14.7994 11.3637 16.8388 10.001 19.0833 9.07131C21.3279 8.1416 23.7335 7.66308 26.163 7.66308C28.5924 7.66308 30.9981 8.1416 33.2426 9.07131C35.4871 10.001 37.5266 11.3637 39.2445 13.0816L26.163 26.1631L13.0815 39.2446Z"
          fill="url(#paint1_linear_711_48125)"
        />
      </g>
      <mask id="path-7-inside-2_711_48125" fill="white">
        <path d="M38.2355 14.9308C35.2853 11.759 31.2055 9.87555 26.8778 9.68743C22.5502 9.49932 18.3223 11.0217 15.108 13.9255C11.8937 16.8294 9.95122 20.8814 9.7003 25.2058C9.44937 29.5303 10.9102 33.7798 13.7671 37.0359L14.3564 36.5188C11.6354 33.4176 10.244 29.3701 10.483 25.2513C10.722 21.1324 12.5721 17.273 15.6336 14.5073C18.6951 11.7415 22.7219 10.2915 26.8438 10.4707C30.9656 10.6499 34.8515 12.4438 37.6614 15.4648L38.2355 14.9308Z" />
      </mask>
      <path
        d="M38.2355 14.9308C35.2853 11.759 31.2055 9.87555 26.8778 9.68743C22.5502 9.49932 18.3223 11.0217 15.108 13.9255C11.8937 16.8294 9.95122 20.8814 9.7003 25.2058C9.44937 29.5303 10.9102 33.7798 13.7671 37.0359L14.3564 36.5188C11.6354 33.4176 10.244 29.3701 10.483 25.2513C10.722 21.1324 12.5721 17.273 15.6336 14.5073C18.6951 11.7415 22.7219 10.2915 26.8438 10.4707C30.9656 10.6499 34.8515 12.4438 37.6614 15.4648L38.2355 14.9308Z"
        stroke="url(#paint2_linear_711_48125)"
        strokeWidth="4"
        mask="url(#path-7-inside-2_711_48125)"
      />
      <g filter="url(#filter3_f_711_48125)">
        <ellipse
          cx="37.6246"
          cy="30.7857"
          rx="1.00543"
          ry="1.00543"
          fill="#85A5FF"
        />
      </g>
      <g filter="url(#filter4_f_711_48125)">
        <circle cx="30.1843" cy="30.9868" r="1.20652" fill="#D3FFA0" />
      </g>
      <g filter="url(#filter5_f_711_48125)">
        <circle cx="28.1738" cy="39.0307" r="1.20652" fill="#FD88FF" />
      </g>
      <g filter="url(#filter6_f_711_48125)">
        <ellipse
          cx="37.2225"
          cy="20.732"
          rx="1.00543"
          ry="1.00543"
          fill="#FD88FF"
        />
      </g>
      <g filter="url(#filter7_d_711_48125)">
        <ellipse
          cx="16.3091"
          cy="23.1445"
          rx="2.89256"
          ry="2.89256"
          fill="white"
        />
      </g>
      <path
        d="M16.308 25.5106C17.6151 25.5106 18.6747 24.451 18.6747 23.144C18.6747 21.8369 17.6151 20.7773 16.308 20.7773C16.2449 20.7773 16.1824 20.7798 16.1205 20.7847L16.2719 21.4541L16.4596 21.3405L16.4448 21.6931C16.587 21.6993 16.722 21.774 16.8003 21.9035L17.1978 22.5604L16.9731 22.8246L16.4047 22.5378C16.3565 22.5132 16.3048 22.5676 16.3332 22.6145L16.7398 23.2863C16.7682 23.3334 16.7934 23.3683 16.8144 23.3975C16.8756 23.4825 16.9019 23.5191 16.8734 23.6642L17.5548 23.7941L17.7292 24.2686L17.4617 24.5259L17.3122 24.0479L16.7706 24.1207L16.4619 24.416C16.4225 24.4399 16.3797 24.4581 16.3388 24.4752L15.4755 24.7925C15.4755 24.7925 15.5221 25.1392 15.4035 25.3316C15.6822 25.447 15.9877 25.5106 16.308 25.5106Z"
        fill="#B37FEB"
      />
      <path
        d="M14.0597 23.8849C14.1305 23.8738 14.2051 23.8723 14.279 23.8807C14.3291 23.8068 14.3996 23.7411 14.4841 23.69L15.5632 23.0369L15.5064 22.943C15.2554 22.5283 15.388 21.9891 15.8027 21.738L16.1164 20.785C14.899 20.8826 13.9414 21.9014 13.9414 23.144C13.9414 23.4027 13.9829 23.6518 14.0597 23.8849Z"
        fill="#B37FEB"
      />
      <g filter="url(#filter8_d_711_48125)">
        <circle cx="25.9618" cy="16.7093" r="3.82065" fill="white" />
      </g>
      <path
        d="M26.1407 14.792L26.1603 14.3263L25.9124 14.4763L25.7125 13.5928C25.7946 13.5863 25.8775 13.583 25.9612 13.583C27.6876 13.583 29.0872 14.9826 29.0872 16.709C29.0872 18.4354 27.6876 19.835 25.9612 19.835C25.5376 19.835 25.1337 19.7507 24.7653 19.5981C24.922 19.344 24.8605 18.8858 24.8605 18.8858L26.0007 18.4667C26.0548 18.4441 26.1113 18.4201 26.1634 18.3885L26.5712 17.9984L27.2865 17.9024L27.484 18.5337L27.8373 18.1939L27.6069 17.567L26.7069 17.3955C26.7446 17.2038 26.7099 17.1555 26.629 17.0433C26.6012 17.0047 26.568 16.9585 26.5304 16.8964L25.9933 16.009C25.9558 15.947 26.0241 15.8752 26.0878 15.9077L26.8386 16.2865L27.1355 15.9375L26.6104 15.0699C26.5069 14.8989 26.3286 14.8002 26.1407 14.792Z"
        fill="#FFD666"
      />
      <path
        d="M22.9912 17.6869C22.89 17.3792 22.8352 17.0505 22.8352 16.709C22.8352 15.0682 24.0993 13.7227 25.7068 13.5932L25.2927 14.8513C24.7449 15.1829 24.5697 15.8951 24.9013 16.443L24.9763 16.5669L23.5509 17.4295C23.4394 17.497 23.3463 17.5839 23.2801 17.6815C23.1827 17.6704 23.0845 17.6723 22.9912 17.6869Z"
        fill="#FFD666"
      />
      <g filter="url(#filter9_d_711_48125)">
        <circle cx="19.3252" cy="32.5966" r="2.41304" fill="white" />
      </g>
      <path
        d="M19.4382 31.3867L19.4506 31.0926L19.294 31.1874L19.1678 30.6292C19.2198 30.6251 19.2723 30.623 19.3254 30.623C20.4158 30.623 21.2997 31.507 21.2997 32.5974C21.2997 33.6877 20.4158 34.5717 19.3254 34.5717C19.0577 34.5717 18.8025 34.5184 18.5697 34.4219C18.6685 34.2614 18.6297 33.9724 18.6297 33.9724L19.3498 33.7076C19.384 33.6934 19.4197 33.6782 19.4526 33.6583L19.7101 33.4119L20.1619 33.3512L20.2866 33.7499L20.5097 33.5353L20.3643 33.1394L19.7958 33.0311C19.8196 32.91 19.7977 32.8795 19.7466 32.8086C19.7291 32.7843 19.7081 32.7551 19.6843 32.7159L19.3451 32.1554C19.3214 32.1162 19.3646 32.0709 19.4048 32.0914L19.879 32.3307L20.0665 32.1103L19.7349 31.5623C19.6695 31.4543 19.5569 31.3919 19.4382 31.3867Z"
        fill="#73D13D"
      />
      <path
        d="M17.4496 33.215C17.3857 33.0207 17.3511 32.8131 17.3511 32.5974C17.3511 31.5612 18.1492 30.7116 19.1642 30.6295L18.9026 31.4242C18.5566 31.6336 18.446 32.0835 18.6554 32.4295L18.7028 32.5078L17.8026 33.0526C17.7321 33.0952 17.6733 33.1501 17.6315 33.2117C17.5702 33.2047 17.5084 33.2059 17.4496 33.215Z"
        fill="#73D13D"
      />
      <path
        opacity="0.9"
        d="M43.3079 16.8955L42.6315 16.3962C42.6082 16.3794 42.5786 16.3748 42.5514 16.3839L41.7576 16.6594C41.6891 16.6834 41.6233 16.618 41.6459 16.5495L41.9105 15.7501C41.9196 15.7229 41.9144 15.6925 41.8976 15.6699L41.3909 14.9985C41.3471 14.9409 41.389 14.8582 41.4613 14.8582L42.3017 14.8633C42.3301 14.8633 42.3572 14.8497 42.3739 14.8258L42.8548 14.1351C42.8961 14.0756 42.9878 14.0898 43.0097 14.1583L43.264 14.961C43.2724 14.9882 43.2943 15.0095 43.3221 15.0179L44.1263 15.2624C44.1954 15.2837 44.2109 15.3749 44.1515 15.417L43.4686 15.9079C43.4454 15.9247 43.4318 15.9519 43.4325 15.9803L43.4486 16.8224C43.448 16.8961 43.366 16.9388 43.3079 16.8955Z"
        fill="#69C0FF"
      />
      <path
        d="M42.9864 13.4049L41.6627 13.1293C41.6174 13.1201 41.5701 13.1326 41.537 13.1633L40.552 14.0607C40.4675 14.1377 40.3276 14.0874 40.3161 13.9757L40.1782 12.6747C40.1734 12.6303 40.1464 12.5911 40.1058 12.5696L38.918 11.9419C38.8159 11.8877 38.822 11.744 38.9288 11.6983L40.1673 11.1692C40.2099 11.151 40.2404 11.1144 40.2485 11.07L40.4993 9.78461C40.5209 9.67423 40.6642 9.63505 40.742 9.7193L41.6452 10.6938C41.6763 10.7271 41.7216 10.7434 41.7675 10.7382L43.1101 10.5716C43.2257 10.5573 43.3082 10.6774 43.2494 10.7748L42.5693 11.906C42.5463 11.9445 42.5443 11.9915 42.5639 12.032L43.1426 13.2142C43.1926 13.3161 43.1 13.4284 42.9864 13.4049Z"
        fill="#FFE58F"
      />
      <path
        opacity="0.9"
        d="M42.1739 41.0263L41.4974 40.527C41.4742 40.5102 41.4445 40.5057 41.4174 40.5147L40.6235 40.7903C40.5551 40.8142 40.4893 40.7489 40.5119 40.6803L40.7765 39.8809C40.7855 39.8537 40.7804 39.8233 40.7636 39.8007L40.2569 39.1294C40.213 39.0718 40.255 38.989 40.3273 38.989L41.1676 38.9942C41.196 38.9942 41.2231 38.9806 41.2399 38.9567L41.7208 38.2659C41.7621 38.2064 41.8537 38.2206 41.8757 38.2892L42.13 39.0918C42.1384 39.119 42.1603 39.1404 42.1881 39.1488L42.9923 39.3932C43.0613 39.4146 43.0768 39.5058 43.0175 39.5478L42.3346 40.0387C42.3113 40.0555 42.2978 40.0827 42.2984 40.1112L42.3146 40.9532C42.3139 41.027 42.232 41.0697 42.1739 41.0263Z"
        fill="#FFF1B8"
      />
      <path
        d="M43.576 38.7428L42.2523 38.4672C42.207 38.4581 42.1597 38.4705 42.1266 38.5012L41.1416 39.3986C41.0571 39.4756 40.9172 39.4253 40.9057 39.3137L40.7678 38.0126C40.763 37.9682 40.736 37.929 40.6954 37.9075L39.5076 37.2798C39.4055 37.2256 39.4116 37.0819 39.5184 37.0362L40.7569 36.5071C40.7995 36.4889 40.83 36.4523 40.8381 36.4079L41.0889 35.1225C41.1105 35.0121 41.2538 34.9729 41.3316 35.0572L42.2348 36.0317C42.2659 36.065 42.3112 36.0813 42.3571 36.0761L43.6997 35.9095C43.8153 35.8952 43.8978 36.0153 43.839 36.1127L43.1589 37.2439C43.1359 37.2824 43.1339 37.3294 43.1535 37.3699L43.7322 38.5521C43.7822 38.654 43.6896 38.7663 43.576 38.7428Z"
        fill="#91D5FF"
      />
      <defs>
        <filter
          id="filter0_d_711_48125"
          x="1.66235"
          y="3.66113"
          width="49"
          height="49"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.503958 0 0 0 0 0.584126 0 0 0 0 0.683333 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_711_48125"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_711_48125"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_711_48125"
          x="23.8662"
          y="12.3398"
          width="16.6323"
          height="16.6553"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.588235 0 0 0 0 0.992157 0 0 0 0 0.486275 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_711_48125"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_711_48125"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_f_711_48125"
          x="1.66309"
          y="1.66309"
          width="43.5813"
          height="43.5811"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3"
            result="effect1_foregroundBlur_711_48125"
          />
        </filter>
        <filter
          id="filter3_f_711_48125"
          x="34.6191"
          y="27.7803"
          width="6.01099"
          height="6.01074"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1"
            result="effect1_foregroundBlur_711_48125"
          />
        </filter>
        <filter
          id="filter4_f_711_48125"
          x="26.9778"
          y="27.7803"
          width="6.41309"
          height="6.41309"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1"
            result="effect1_foregroundBlur_711_48125"
          />
        </filter>
        <filter
          id="filter5_f_711_48125"
          x="24.9673"
          y="35.8242"
          width="6.41309"
          height="6.41309"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1"
            result="effect1_foregroundBlur_711_48125"
          />
        </filter>
        <filter
          id="filter6_f_711_48125"
          x="34.217"
          y="17.7266"
          width="6.01099"
          height="6.01074"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1"
            result="effect1_foregroundBlur_711_48125"
          />
        </filter>
        <filter
          id="filter7_d_711_48125"
          x="9.4165"
          y="16.252"
          width="13.7852"
          height="13.7852"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.8 0 0 0 0 0.556863 0 0 0 0 0.839216 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_711_48125"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_711_48125"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_d_711_48125"
          x="18.1411"
          y="8.88867"
          width="15.6414"
          height="15.6416"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.988235 0 0 0 0 0.890196 0 0 0 0 0.564706 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_711_48125"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_711_48125"
            result="shape"
          />
        </filter>
        <filter
          id="filter9_d_711_48125"
          x="12.9121"
          y="26.1836"
          width="12.8262"
          height="12.8262"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.588235 0 0 0 0 0.992157 0 0 0 0 0.486275 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_711_48125"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_711_48125"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_711_48125"
          x1="26.3755"
          y1="26.4452"
          x2="38.0724"
          y2="14.7668"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#44ADFE" />
          <stop offset="0.21875" stopColor="#BEF8D5" />
          <stop offset="0.438241" stopColor="#D0ECA4" />
          <stop offset="0.794105" stopColor="#F0956A" />
          <stop offset="1" stopColor="#FF696A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_711_48125"
          x1="38.5"
          y1="15"
          x2="14.998"
          y2="37.9867"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF846A" stopOpacity="0.68" />
          <stop offset="0.25" stopColor="#FDC869" stopOpacity="0.77" />
          <stop offset="0.5" stopColor="#96FD7C" stopOpacity="0.56" />
          <stop offset="0.759663" stopColor="#7DF1FC" stopOpacity="0.26" />
          <stop offset="1" stopColor="#BE91F8" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_711_48125"
          x1="36.2161"
          y1="13.6936"
          x2="12.0857"
          y2="33.199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE6D6B" />
          <stop offset="0.354167" stopColor="#CDEFAE" />
          <stop offset="0.671875" stopColor="#CEB4F0" />
          <stop offset="1" stopColor="#10239E" />
        </linearGradient>
      </defs>
    </svg>
  );
};
